module.exports = __webpack_public_path__ + "media/images/cus_4-1b723e0dd78918db192a5b656a69c7f9.png";